import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.reset-password-verify', {
        url: '/resetpwd/:appKey?rkey&appName&username&autoRedirect',
        resolve:{appData,rkey,appName,username,autoRedirect},
        component:'resetPasswordVerify'
    });
}

/** @ngInject */
function appData($stateParams,SamlService) {
    return SamlService.getAppAccountFormat.get({appKey : $stateParams.appKey}).$promise
}

/** @ngInject */
function rkey($stateParams) {
    return $stateParams.rkey
}
/** @ngInject */
function autoRedirect($stateParams) {
    return $stateParams.autoRedirect
}
/** @ngInject */
function username($stateParams) {
    return $stateParams.username
}
/** @ngInject */
function appName($stateParams) {
    return $stateParams.appName
}


// WEBPACK FOOTER //
// ./src/portal/states/public/reset-password-verify/reset-password-verify.state.js